import React, { useState } from 'react';
import { Button, Input, message, Popconfirm, Select, Typography } from 'antd';
import { DeleteOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useCsaTaggingList } from '../../hooks/useOrders';

const CSATagDataModalContent = ({ selectedProduct, tagDataPairs, setTagDataPairs, onRemoveExistingTag, companyCode }) => {
    const [taggingData, setTaggingData] = useState(null);

    useCsaTaggingList(
        { companyCode },
        res => setTaggingData(res?.data ?? null),
        error => {
            message.error(error?.message ?? 'Failed to fetch tagging data');
        }
    );

    const keyOptions = Array.isArray(taggingData)
        ? taggingData.map(item => ({ label: item.key, value: item.key }))
        : [];

    const valueOptionsByKey = Array.isArray(taggingData)
        ? taggingData.reduce((acc, item) => {
              acc[item.key] = Array.isArray(item.values)
                  ? item.values.map(v => ({ label: String(v), value: String(v) }))
                  : [];
              return acc;
          }, {})
        : {};

    const filterOption = (input, option) =>
        String(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {selectedProduct?.tagData && Object.keys(selectedProduct.tagData).length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <Typography.Text strong>Existing Tag Data</Typography.Text>
                    {Object.entries(selectedProduct.tagData).map(([k, v]) => (
                        <div key={k} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                            <Typography.Text
                                style={{ flex: 1, background: '#f5f5f5', padding: '4px 11px', borderRadius: 6, border: '1px solid #d9d9d9' }}
                            >
                                {k}
                            </Typography.Text>
                            <Input style={{ flex: 1 }} value={String(v ?? '')} readOnly />
                            <Popconfirm
                                title="Delete tag"
                                description="Are you sure you want to delete this tag?"
                                onConfirm={() => onRemoveExistingTag && onRemoveExistingTag(k)}
                                onCancel={() => {}}
                                okText="Yes"
                                cancelText="No"
                            >
                                <DeleteOutlined style={{ color: 'rgba(0,0,0,0.45)', cursor: 'pointer', fontSize: 12 }} />
                            </Popconfirm>
                        </div>
                    ))}
                </div>
            )}
            <Typography.Text strong>Add New Fields</Typography.Text>
            {tagDataPairs.map((pair, index) => (
                <div key={index} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <Select
                        showSearch
                        allowClear
                        mode="tags"
                        maxTagCount={1}
                        placeholder="Key"
                        value={pair.key ? [pair.key] : []}
                        options={keyOptions}
                        style={{ flex: 1 }}
                        filterOption={filterOption}
                        onChange={vals => {
                            const next = [...tagDataPairs];
                            const newKey = Array.isArray(vals) ? (vals[vals.length - 1] ?? '') : '';
                            next[index] = {
                                ...next[index],
                                key: newKey,
                                value: newKey === pair.key ? next[index].value : '',
                            };
                            setTagDataPairs(next);
                        }}
                    />
                    <Select
                        showSearch
                        allowClear
                        mode="tags"
                        maxTagCount={1}
                        placeholder="Value"
                        disabled={!pair.key}
                        value={pair.value ? [String(pair.value)] : []}
                        options={valueOptionsByKey[pair.key] ?? []}
                        style={{ flex: 1 }}
                        filterOption={filterOption}
                        onChange={vals => {
                            const next = [...tagDataPairs];
                            const newVal = Array.isArray(vals) ? (vals[vals.length - 1] ?? '') : '';
                            next[index] = { ...next[index], value: newVal };
                            setTagDataPairs(next);
                        }}
                    />
                    {tagDataPairs.length > 1 && <MinusCircleOutlined onClick={() => setTagDataPairs(tagDataPairs.filter((_, i) => i !== index))} />}
                </div>
            ))}
            <Button type="dashed" icon={<PlusOutlined />} onClick={() => setTagDataPairs([...tagDataPairs, { key: '', value: '' }])}>
                Add field
            </Button>
        </div>
    );
};

export default CSATagDataModalContent;
